import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Frame from "../components/Frame";
import { STEPS } from "../consts";

export default function GoToParkEntry() {
    const { t } = useTranslation();
    return (
        <>
            <Frame
                step={STEPS.HOME}
            >
                <Stack
                    alignItems={'center'}
                    justifyContent='center'
                    height={'100%'}
                >
                    <Typography
                        color='white'
                        fontSize='1.9rem'
                        style={{ textAlign: 'center' }}
                    >
                        {t('GO_TO_PARK_ENTRY')}
                    </Typography>
                </Stack>
            </Frame >
        </>
    );
}